// src/App.js
import React from "react";
import { AppRoutes } from "./routes/AppRoutes";
import "./styles/globals.css";
import "./styles/variables.css";

function App() {
  return <AppRoutes />;
}

export default App;
